
import { createAction, props } from '@ngrx/store';
import { ValidarUsuarioDto } from '../dto/validarUsuarioDto';
import { SessionDto } from '../../../core/data/SessionDto';
import { OpcionesPerfilRolDto } from 'src/app/core/data/OpcionesPerfilRolDto';

// COM Session****
export const addSession = createAction(
  '[ADD SS] ',
  props<{ _newSession: SessionDto }>()
);

export const removeSession = createAction(
  '[REMOVE SS]',
);

// COM Session Temporal****
export const addTemporalSession = createAction(
  '[ADD TEMPORAL] ',
  props<{ _newTemporalSession: ValidarUsuarioDto }>()
);

export const removeTemporalSession = createAction(
  '[REMOVE TEMPORAL]',
);


// COM Perfiles****
export const addPerfil = createAction(
  '[ADD PR] ',
  props<{ newPerfil: OpcionesPerfilRolDto }>()
);

export const removePerfil = createAction(
  '[REMOVE PR]',
);









